// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2BP8M","header":"Messages_header__1ekYD"};